<template>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="error-template">
            <img alt="Linc logo" src="../assets/v2/images/logo-linc.png" class="lincLogo">
             
            <div class="error-details">
               Customer Satisfaction Survey 
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  

  <script>
    export default {

      name: "WelcomePage",
      components: {
        
      },

      props: {

      },

      data() {
        return {
          forms: {},
        };
      },

      computed: {
        
      },

      watch: {

      },

      methods: {

      

      },


      events: {

      },

      created: function () {
        
      },

      mounted() {

        setTimeout(() => {
          window.location.href = 'https://www.lincgrp.com/en';
        }, 5000); // 5000 milliseconds = 5 seconds


      },

      updated() {


      },

      onLoad(){


      }


    }
  </script>

  <style scoped>
  .error-template {padding: 40px 15px;text-align: center;}
  .error-actions {margin-top:15px;margin-bottom:15px;}
  .error-actions .btn { margin-right:10px; }
  .container{
    align-content: center;
    height: auto;
  }
  .lincLogo {
    height: 300px;
    width: auto;
  }
  </style>